<template>
    <MenuBase :hidden="props.hidden" 
        :tooltipPosition="props.tooltipPosition" :theme="props.theme" 
        :tooltipText="props.tooltipText"
        :active="active"
        @menuClick="toggleDrawing()">
        <PaintBrushIcon class="w-6 h-6" />
    </MenuBase>
</template>
<script setup>
import { defineProps, ref } from 'vue'
import { PaintBrushIcon } from '@heroicons/vue/24/outline';
import MenuBase from '@/components/common/menus/MenuBase.vue';
import { appEvents } from '@/store/app.events';
import drawingStore from '@/store/drawing.store';

//const emit = defineEmits(['toggleDrawing'])
const active = ref(drawingStore.state.drawingEnabled);
const props = defineProps( {
    disabled: {
        type: Boolean,
        default: true
    },
    hidden: {
        type: Boolean,
        default: true
    },
    tooltipPosition: {
        type: String,
        default: 'top'
    },
    theme: {
        type: String,
        default: 'light'
    },
    tooltipText: {
        type: String,
        default: 'Realtime drawing'
    }
})

const toggleDrawing = () => {
    drawingStore.state.drawingEnabled = !drawingStore.state.drawingEnabled;
    active.value = drawingStore.state.drawingEnabled;
    appEvents.emit('toggleDrawing', drawingStore.state.drawingEnabled);
}
appEvents.on('currentDrawingState', (value) => {
    active.value = value;
    drawingStore.state.drawingEnabled = value;
    appEvents.emit('toggleDrawing', value);
});
</script>